import React from 'react';
import './noqrView.css';
import noQrImg from './../assets/img/icon/qrCodeError.png';
import logo from '../assets/logo_text.png';
import playStoreLogo from '../assets/img/icon/playStore.png';
import appStoreLogo from '../assets/img/icon/appleStore.png';

function NoQrView() {
    return (
        <div className='noqr-page'>
            <div className='noqr-card'>
                {/* Error content */}
                <div className='noqr-content'>
                    <img className="noqr-icon" src={noQrImg} alt="QR Error" />
                    <h2 className='noqr-title'>QR Code Not Available</h2>
                    <p className='noqr-message'>
                        The QR code you scanned is invalid or has expired.
                        Please try scanning again or contact support.
                    </p>
                </div>

                {/* Footer with logo and app links */}
                <div className="noqr-footer">
                    <div className="noqr-footer-content">
                        <img src={logo} alt="Food Allergy Card" className="noqr-footer-logo" />
                        <div className="noqr-footer-download">
                            <p>Download the app</p>
                            <a href="https://play.google.com/store/apps/details?id=com.foodallergycard" target="_blank" rel="noopener noreferrer">
                                <img src={playStoreLogo} alt="Play Store" className="noqr-footer-store" />
                            </a>
                            <a href="https://apps.apple.com/app/food-allergy-card/id6448350429" target="_blank" rel="noopener noreferrer">
                                <img src={appStoreLogo} alt="App Store" className="noqr-footer-store" />
                            </a>
                        </div>
                    </div>
                    <p className="noqr-footer-copyright">&copy; {new Date().getFullYear()} Food Allergy Card. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
}

export default NoQrView;
